import { useState, useEffect, useContext } from 'react';
import Header from 'widgets/header';
import { Input } from '@acko-tech/building-blocks.ui.input';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
// import Checkbox from 'library/checkbox';
import { useSegmentViewEvents } from 'hooks/useSegmentView';
import { SegmentPages, SegmentViewEvents } from 'utils/segment/constants';
import { MPosContext } from 'utils/context';
import { useRouter } from 'next/router';
import { IOrderDetails } from './types';
import ErrorPage from 'widgets/errorScreen';
import { getPlanName } from 'utils/generics';
import SnackBar from 'library/snackbar';
import * as Styles from './styles';

function Payment() {
    const router = useRouter();
    const { order_ekey } = router.query;

    const { partnerId, dealerType } = useContext(MPosContext);

    const [orderDetails, setOrderDetails] = useState<IOrderDetails | null>(
        null
    );
    const [isLoading, setIsLoading] = useState(true);
    // const [isCheckboxSelected, setIsCheckboxSelected] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [snackbar, setSnackbar] = useState({
        type: '',
        message: '',
    });
    const [isBtnLoading, setIsBtnLoading] = useState(false);

    /**
     * view segment hook
     */
    useSegmentViewEvents(SegmentViewEvents.VIEW_DEALER_PAYMENT, {
        page: SegmentPages.PAYMENT,
        product: 'pos',
        journey: 'buy',
        platform: 'mweb',
        partner: partnerId,
        type: dealerType,
    });

    useEffect(() => {
        import('./apis').then(async (req) => {
            const { status, data, statusCode } =
                await req.getCustomerPlanDetails(partnerId, order_ekey);
            if (statusCode === 401) {
                router.push('/login');
                setSnackbar({
                    type: 'failure',
                    message: 'Token expired. Redirecting to login page.',
                });
                return;
            }
            setIsLoading(false);
            if (status && data?.recent_orders?.length > 0) {
                setOrderDetails(data.recent_orders[0]);
                setErrorMessage('');
            } else {
                setErrorMessage('Oops. something went wrong.');
            }
        });
    }, []);

    const onPayNow = () => {
        setIsBtnLoading(true);
        import('./apis').then(async (req) => {
            const { data, status, statusCode } = await req.dealerPayment(
                partnerId,
                order_ekey
            );
            setIsBtnLoading(false);
            if (statusCode === 401) {
                router.push('/login');
                setSnackbar({
                    type: 'failure',
                    message: 'Token expired. Redirecting to login page.',
                });
                return;
            }
            if (status && data) {
                if (status && data?.payment_gateway_url) {
                    window.location.href = `${data.payment_gateway_url}?id=${data?.payment_order_ekey}`;
                }
                return;
            }
            setSnackbar({
                type: 'failure',
                message: 'Oops. Something went wrong.',
            });
        });
    };

    // const onClickTnc = () => {
    //     window.open(
    //         'https://templates.corp.ackodev.com/templateservice/t/mPOS_dealer_TnC/1.0',
    //         '_target'
    //     );
    // };

    if (isLoading) {
        return <></>;
    }

    if (errorMessage) {
        return <ErrorPage />;
    }

    return (
        <Styles.Wrapper>
            <Styles.HeaderWrapper>
                <Header />
            </Styles.HeaderWrapper>
            <Styles.CustomPlanDetailsWrapper>
                <Styles.HeaderTitle>
                    Confirm and pay for your customer
                </Styles.HeaderTitle>
                <Styles.PlanDetailsWrapper>
                    <Styles.RowWrapper>
                        <Styles.LabelText>Device model</Styles.LabelText>
                        <Styles.ValueText>
                            {orderDetails?.device.name}
                        </Styles.ValueText>
                    </Styles.RowWrapper>
                    <Styles.Hr />
                    <Styles.RowWrapper>
                        <Styles.LabelText>VIN</Styles.LabelText>
                        <Styles.ValueText>
                            {orderDetails?.device?.vin}
                        </Styles.ValueText>
                    </Styles.RowWrapper>
                    <Styles.Hr />
                    <Styles.RowWrapper>
                        <Styles.LabelText>BIN</Styles.LabelText>
                        <Styles.ValueText>
                            {getPlanName(orderDetails?.device?.bin || '')}
                        </Styles.ValueText>
                    </Styles.RowWrapper>
                    <Styles.Hr />
                    <Styles.RowWrapper>
                        <Styles.LabelText>RTO</Styles.LabelText>
                        <Styles.ValueText>
                            {orderDetails?.device?.rto_code}
                        </Styles.ValueText>
                    </Styles.RowWrapper>
                </Styles.PlanDetailsWrapper>
            </Styles.CustomPlanDetailsWrapper>
            <Styles.CustomerDetailsFormWrapper>
                <Styles.FormTitle>
                    {`Please find your customer's details`}
                </Styles.FormTitle>
                <Styles.InputWrapper>
                    <Input
                        name={'name'}
                        type={'text'}
                        className={''}
                        value={orderDetails?.customer.name || ''}
                        onChange={() => {}}
                        labelText={'Full name'}
                        disabled={true}
                    />
                </Styles.InputWrapper>
                <Styles.InputWrapper>
                    <Input
                        name={'email'}
                        type={'text'}
                        className={''}
                        value={orderDetails?.customer?.email || ''}
                        onChange={() => {}}
                        labelText={'Email address'}
                        disabled={true}
                    />
                </Styles.InputWrapper>
                <Styles.InputWrapper>
                    <Input
                        name={'mobile'}
                        type={'text'}
                        className={''}
                        value={orderDetails?.customer.phone || ''}
                        onChange={() => {}}
                        labelText={'Mobile number'}
                        disabled={true}
                    />
                </Styles.InputWrapper>
                <Styles.InputWrapper>
                    <Input
                        name={'address'}
                        type={'text'}
                        className={''}
                        value={orderDetails?.customer?.address || ''}
                        onChange={() => {}}
                        labelText={'Address'}
                        disabled={true}
                    />
                </Styles.InputWrapper>
                <Styles.InputWrapper>
                    <Input
                        name={'pincode'}
                        type={'number'}
                        className={''}
                        value={orderDetails?.customer?.pincode || ''}
                        onChange={() => {}}
                        labelText={'Pincode'}
                        disabled={true}
                    />
                </Styles.InputWrapper>
                {/* <Styles.TncWrapper>
                    <Styles.CheckboxFlex>
                        <Checkbox
                            isSelected={isCheckboxSelected}
                            onSelectHandler={() => {
                                setIsCheckboxSelected((s) => !s);
                            }}
                            color={'#0FA457'}
                        />
                    </Styles.CheckboxFlex>
                    <Styles.TncText onClick={onClickTnc}>
                        I agree to the Terms and conditions
                    </Styles.TncText>
                </Styles.TncWrapper> */}
            </Styles.CustomerDetailsFormWrapper>
            <Styles.Hr1 />
            <Styles.PriceDetailsFlex>
                <Styles.Price>₹{orderDetails?.plan.premium}</Styles.Price>
                <Styles.Tax>(incl 18% GST)</Styles.Tax>
                <Styles.PayNowButton>
                    <PrimaryButton
                        loading={isBtnLoading}
                        size={'small'}
                        // disabled={!isCheckboxSelected}
                        onClick={onPayNow}
                    >
                        Pay now
                    </PrimaryButton>
                </Styles.PayNowButton>
            </Styles.PriceDetailsFlex>
            <SnackBar
                {...snackbar}
                handleSnakbarComplete={() =>
                    setSnackbar({ type: '', message: '' })
                }
            />
        </Styles.Wrapper>
    );
}

export default Payment;
